// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "menu-column td.over {\n  background: #0A246A;\n}\nmenu-column td.over a {\n  color: white;\n}\nmenu-column td.out {\n  background: \"\";\n}\nmenu-column td.out a {\n  color: black;\n}\nmenu-column div.menu {\n  z-index: 1;\n  position: absolute;\n}\nmenu-column div.active {\n  display: inline;\n}\nmenu-column div.inactive {\n  display: none;\n}\nmenu-column td.menu-item[disabled=disabled] a {\n  color: #909090;\n}\nmenu-column a {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
